import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'gatsby'

const LanguageButton = styled.div`
    text-transform: uppercase;
    color: ${(props) => props.theme.colors.lightGreenText};
    font-size: 20px;
    float: right;
    width: 10%;
    margin: 20px;
`

export const LanguageSelector = (props) => {
    const { pageContext: { localePaths, locale, customerType } } = props

    const getLocaleLanguage = (localeString) => {
        return localeString.split('-')[0]
    }
    return (
        <div>
            <>
                {Object.keys(localePaths[customerType]).map((key, index) => {
                    if( key === locale) {
                        return null
                    }

                    return <Link key={index} to={localePaths[customerType][key]}>
                        <LanguageButton>{getLocaleLanguage(key)}</LanguageButton>
                    </Link>
                })}
            </>
        </div>
    )
}

LanguageSelector.propTypes = {
    locale: PropTypes.string,
    localePaths: PropTypes.object,
    pageContext: PropTypes.object,
}
